<template>
  <div class="topic-edit">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" size="small">
      <div class="white-container">
        <el-form-item label="俱乐部名称" prop="name" style="width: 500px">
          <el-input v-model="form.name" placeholder="请输入俱乐部名称最多不超过10个字" maxlength="10" :disabled="disabled" />
        </el-form-item>

        <!-- <el-form-item label="俱乐部地区" prop="region" style="width:300px">
          <el-select v-model="form.region" placeholder="请选择地区" :disabled="disabled">
            <el-option v-for="item in cityList" :key="item" :label="item" :value="item" />
          </el-select>
        </el-form-item> -->

        <el-form-item label="俱乐部地区" prop="selectedRegion" style="width:300px">
          <el-cascader v-model="form.selectedRegion" :options="cityOptions" placeholder="请选择俱乐部省/市" clearable />
        </el-form-item>

        <el-form-item label="Leader姓名" prop="leaderName" style="width: 500px">
          <el-select v-model="form.leaderName" clearable filterable remote lterable placeholder="搜索昵称" :disabled="disabled" :remote-method="remoteMethod" @keyup.enter.native="selectQuery" @change="handleLeaderChange">
            <el-option v-for="item in leaderList" :key="item.id" :label="item.leaderName + '(' + item.leaderPhone + ')' " :value="item.leaderName">
              <span style="color: #000">{{ item.leaderName }}</span>
              <span style="color: #999">
                {{ '('+item.leaderPhone+')' }}
              </span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Slogan" prop="slogan" style="width: 500px">
          <el-input v-model="form.slogan" placeholder="请输入俱乐部Slogan，最多不超过20个字" maxlength="20" :disabled="disabled" />
        </el-form-item>

        <el-form-item label="俱乐部介绍" prop="description" style="width: 100%">
          <el-input v-model="form.description" type="textarea" placeholder="请输入俱乐部介绍，最多不超过90个字" :disabled="disabled" maxlength="90" />
        </el-form-item>

        <div v-if="form.id ">
          <el-form-item label="发起活动次数" style="width: 100%">{{ form.eventNumber }}次</el-form-item>
          <el-form-item label="成员数量" style="width: 100%">{{ form.memberNumber }}人</el-form-item>
        </div>

        <el-form-item label="是否主推" prop="isRecommend" style="width: 500px; white-space: nowrap">
          <div class="flex form-radio">
            <el-radio v-model="form.isRecommend" :label="0">是</el-radio>
            <el-radio v-model="form.isRecommend" :label="1">否</el-radio>
          </div>
        </el-form-item>

        <el-form-item label="是否官方俱乐部" prop="isOfficialClub" style="width: 500px; white-space: nowrap">
          <div class="flex form-radio">
            <el-radio v-model="form.isOfficialClub" :label="0">是</el-radio>
            <el-radio v-model="form.isOfficialClub" :label="1">否</el-radio>
          </div>
        </el-form-item>

      </div>
      <div class="white-container marginTop">
        <div class="img-text"><span>*</span> 上传图片</div>
        <div class="flex">
          <el-form-item label="" prop="logo" class="image-config">
            <div class="flex uploadImg-cont">
              <UploadImage :disabled="disabled" title="俱乐部头像" :url="form.logo" save-path="running/" size-tips="360px*360px" @triggerReg="handleCheckChartReg" @upload="data => (form.logo = data)" />
            </div>
          </el-form-item>

          <el-form-item label="" prop="qrCodeUrl" class="image-config">
            <div class="flex uploadImg-cont">
              <UploadImage :disabled="disabled" title="俱乐部leader企微二维码" :url="form.qrCodeUrl" save-path="running/" size-tips="360px*360px" @triggerReg="handleCheckChartReg2" @upload="data => (form.qrCodeUrl = data)" />
            </div>
          </el-form-item>
        </div>

        <el-form-item v-if="form.id" style="width:100%;margin-top:80px;margin-left:-50px">
          <div class="flex btns">
            <el-button type="info" @click="cancel">取消</el-button>
            <el-button type="primary" @click="submit">保存</el-button>
          </div>
        </el-form-item>
      </div>

      <el-form-item v-if="!id" style="width:100%;margin-top:30px;margin-left:-50px">
        <div class="flex btns">
          <el-button type="primary" @click="submit">确定</el-button>
        </div>
      </el-form-item>

    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
  </div>
</template>
<script>
import UploadImage from '@/components/UploadImage';
import Dialog from '@/components/Dialog';
import cityOptions from '@/model/cityCascader';

export default {
  components: { UploadImage, Dialog },
  data() {
    return {
      form: {
        name: '',
        region: '',
        leaderName: '',
        slogan: '',
        description: '',
        eventNumber: 0,
        memberNumber: 0,
        isOfficialClub: 1,
        isRecommend: 1,
        logo: '',
        id: null,
        leaderMemberId: null,
        qrCodeUrl: '',
        selectedRegion: [],
      },

      rules: {
        name: [
          { required: true, message: '请输入俱乐部名称', trigger: 'blur' },
        ],
        // region: [
        //   { required: true, message: '请选择俱乐部地区', trigger: 'change' },
        // ],

        selectedRegion: [
          { required: true, message: '请选择俱乐部地区', trigger: 'change' },
        ],
        leaderName: [
          { required: true, message: '请选择Leader姓名', trigger: 'change' },
        ],
        slogan: [
          { required: true, message: '请输入Slogan', trigger: 'blur' },
        ],
        description: [
          { required: true, message: '请输入俱乐部介绍', trigger: 'blur' },
        ],
        isRecommend: [
          { required: true, message: '请选择是否主推', trigger: 'change' },
        ],
        isOfficialClub: [
          { required: true, message: '请选择是否官方俱乐部', trigger: 'change' },
        ],
        logo: [
          { required: true, message: '请上传俱乐部头像', trigger: 'change' },
        ],
        qrCodeUrl: [
          { required: true, message: '请上传俱乐部leader企微二维码', trigger: 'change' },
        ],
      },
      formDialogShow: false,
      information: {},
      uploadedFile: false,

      cityList: [],
      leaderList: [],
      loading: false,
      id: null,

      cityOptions,
    };
  },
  computed: {
    disabled() {
      return false;
    },

  },
  watch: {},
  mounted() {
    const { query } = this.$route;
    const id = query.id;

    if (query.id) {
      this.id = id;
      this.getActivityDetail(id);
    }
    this.cancelText = query.id ? '编辑' : '新增';
    // this.getCity();
    this.getLeaderList('');
  },
  methods: {
    getActivityDetail(id) {
      this.$Api.rugby.clubDetail({ clubId: id }).then(res => {
        this.form = res;
        this.form.selectedRegion = res.region ? res.region.split(' / ') : [];
      });
    },

    // 城市
    // getCity() {
    //   this.$Api.rugby.cityList({}).then(res => {
    //     this.cityList = res;
    //   });
    // },

    // 搜索
    getLeaderList(leaderName) {
      this.loading = true;
      this.$Api.rugby.searchLeader({ leaderName }).then(res => {
        this.leaderList = res;
        this.loading = false;
      });
    },

    // 远程搜索
    remoteMethod(query) {
      if (query !== '') {
        this.getLeaderList(query);
      } else {
        this.leaderList = [];
      }
    },

    handleLeaderChange(val) {
      const leader = this.leaderList.find(item => item.leaderName === val);
      this.form.leaderMemberId = leader ? leader.id : null;
    },

    handleCheckChartReg(val) {
      this.$refs.form.validateField("logo");
    },
    handleCheckChartReg2(val) {
      this.$refs.form.validateField("qrCodeUrl");
    },

    submit() {
      this.formDialogShow = true;
      const text = this.id ? '是否保存以上修改内容？' : '是否提交以上内容？';
      this.information = {
        operation: "submit",
        icon: "warn",
        subTitle: `${text}`,
      };
    },

    addActivity() {
      const param = { ...this.form };
      if (!(/\.(png|jpg)$/i.test(param.logo))) {
        param.logo = param.logo + '.png';
      }
      if (!(/\.(png|jpg)$/i.test(param.qrCodeUrl))) {
        param.qrCodeUrl = param.qrCodeUrl + '.png';
      }

      param.region = param.selectedRegion.join(' / ');
      delete param.selectedRegion;

      if (this.id) { // 修改
        this.$Api.rugby.clubEdit({ ...param }).then(res => {
          this.$message.success(`保存成功`);
          setTimeout(() => {
            this.goBack();
          }, 2000);
        }).catch(err => {
          if (err && !err.success) {
            this.$message.error(err.errorMessage || `${this.cancelText}失败`);
          }
        });
      } else { // 新增
        delete param.eventNumber;
        delete param.memberNumber;

        this.$Api.rugby.clubAdd({ ...param }).then(res => {
          this.$message.success(`新增成功`);
          setTimeout(() => {
            this.goBack();
          }, 2000);
        }).catch(err => {
          if (err && !err.success) {
            this.$message.error(err.errorMessage || `${this.cancelText}失败`);
          }
        });
      }
    },

    cancel() {
      this.formDialogShow = true;
      this.information = {
        operation: 'delete',
        icon: 'warn',
        subTitle: `是否放弃${this.cancelText}，返回上级页面？`,
      };
    },

    dialogSuccess() {
      if (this.information.operation && this.information.operation === 'delete') {
        this.goBack();
      } else if (this.information.operation && this.information.operation === 'submit') {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.addActivity();
          } else {
            return false;
          }
        });
      }
    },
    goBack() {
      this.$router.back(-1);
    },
  },
};

</script>
<style lang="less" scoped>
.row-cont {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.btns {
  align-items: center;
  justify-content: center;
}
.marginTop {
  margin-top: 30px;
  .img-text {
    margin-bottom: 10px;
    span {
      color: #f56c6c;
      margin-right: 4px;
    }
  }
}
</style>
<style lang="less">
.topic-edit {
  .el-form-item--small.el-form-item {
    margin-bottom: 30px;
    .form-radio {
      line-height: 32px;
      height: 32px;
      align-items: center;
    }
    .el-checkbox__inner::after {
      border-right-width: 2.5px;
      border-bottom-width: 2.5px;
    }
    .el-checkbox__label {
      color: #494949;
    }
    .coupon-uploader {
      margin: unset;
      display: flex;
      height: 34px;
      line-height: 34px;
      .el-button {
        width: 115px;
        height: 34px;
      }
      .coupon_tip {
        width: 250px;
        white-space: nowrap;
        margin-left: 10px;
        margin-right: 20px;
      }
      .download-file {
        white-space: nowrap;
      }
    }
  }
  .coach-select-box + .el-form-item__error {
    top: unset !important;
    bottom: 43px !important;
  }
  .uploadImg-cont {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .uploader {
      margin-bottom: 30px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
  .form-icon {
    margin-left: 10px;
    .el-icon-close {
      color: #9b9b9b;
      cursor: pointer;
      &:hover {
        color: #000000;
      }
    }
  }

  .product-config,
  .image-config {
    margin-right: 30px;
    .el-form-item__label {
      float: none;
    }
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .lng-label .el-form-item__label {
    width: 50px !important;
  }
  .lng-label .el-form-item__content {
    margin-left: 50px !important;
  }
  .btn-form-item.el-form-item--small {
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
}
</style>

